module.exports = __webpack_public_path__ + "static/media/Backbeach.98331272.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Backbeach.png
// module id = 376
// module chunks = 0